import styled from 'styled-components';

export const Styled = styled.div`
    position: relative;
    overflow: hidden;
    background: ${(p) => p.theme.palette.background.default};
    flex-wrap: nowrap;

    .maintenance {
        text-align: center;
        max-width: 500px;
        margin: 0 auto;
    }

    .ue-image-hero .ue-spacer.custom {
        height: 300px;
        ${(p) => p.theme.breakpoints.up('md')} {
            height: 440px;
        }
    }

    .heading.h4 .ue-rich-text {
        font-family: 'Fira_Mono_Bold', 'Brutal_Bold', monospace;
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: 4px;
        text-transform: uppercase;
        margin: 0px;
    }
    .heading.h1 .ue-rich-text {
        font-family: 'Brutal_Light', 'Open Sans', arial;
        font-weight: 300;
        font-size: 66px;
        line-height: 74px;
        letter-spacing: -1px;
        margin: 0px;
    }

    .selectCustom {
        user-select: none;
        float: left;
        .select-label {
            &:focus-visible {
                outline-color: #a6a7ae;
                outline-offset: -2px;
            }
            path {
                stroke: #aaaaae;
                stroke-width: 1.5;
            }
        }
        .has-checked-items .select-label {
                padding-bottom: 7px;
        }
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .selectCustom {
            float: unset;
            border-bottom: 1px solid #303034;
        }
        .select-label {
            width: 100%;
        }
        .select-dropdown {
            position: unset;
            overflow: scroll;
        }
    }

    ${(p) => p.theme.breakpoints.down('md')} {
        .joblisting-product {
            font-weight: bold;
        }

        .joblisting-details-sm {
            color: #aaaaae;
            border-bottom: 1px solid #303034;
            padding-bottom: 10px;
        }
    }

    ${(p) => p.theme.breakpoints.up('md')} {
        .job-results-count {
            float: right;
        }
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .job-results-count {
            text-align: center;
        }
    }
`;

export const Filters = styled.div`
    && {
        color: #e6e6ea;
        background-color: #202024;
        text-align: left;
        position: relative;
        overflow: visible;
        z-index: 2;

        .select-dropdown {
            background-color: #202024;
            .checkbox-option {
                svg {
                    fill: unset!important;
                    path {
                        stroke: #aaaaae;
                    }
                }
            }
            li, li:hover {
                color: #e6e6ea;
            }
        }

        ${(p) => p.theme.breakpoints.down('sm')} {
            position: fixed;
            z-index: 99999;
            left: 0;
            width: 100%;
            top: 0;
            height: 100vh;
            display: none;

            &&.opened-mobile {
                display: block;
                height: 100vh;
                max-height: -webkit-fill-available;
                overflow-y: scroll;
                -webkit-overflow-scrolling: touch;
            }

            .selectCustom .select-dropdown {
                background-color: inherit;
                width: 100%;
                z-index: 1;

                li {
                    padding-left: 0px;
                }

                li.reduce-font-size .paragraph {
                    font-size: 15px;
                }
            }
        }

        .filters-bar,
        .filters-search-bar {
            ${(p) => p.theme.breakpoints.up('lg')} {
                height: 50px;
            }
            background-color: #202024;
            z-index: 2;
            ${(p) => p.theme.breakpoints.down('sm')} {
                padding-left: 13px;
                padding-right: 15px;
                height: auto;
            }
        }
        .remote-eligible-checkbox {
            display: inline-flex;
            margin-top: 0;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 0;
        }

        .remote-eligible-checkbox li {
            display: inline-block;
            margin-bottom: 0px;
            padding: 0px;
            min-height: 30px;
            ${(p) => p.theme.breakpoints.down('sm')} {
                display: block;
            }
            ${(p) => p.theme.breakpoints.down('md')} {
                margin-top: 7px !important;
            }
        }
    }

    &&& .Mui-focusVisible {
        box-shadow: none;
    }
`;

export const FilteredResults = styled.div`
    position: relative;
    min-height: 400px;

    ${(p) => p.theme.breakpoints.down('md')} {
        .filtered-result-row {
            padding-bottom: 10px;
            padding-top: 20px;
        }
    }
    .joblisting-title,
    .rightCarret {
        font-weight: 600;
    }

    .joblisting-title {
        line-height: 22px;
    }

    .joblisting-spotlight {
        height: 0;
    }

    ${(p) => p.theme.breakpoints.only('md')} {
        .joblisting-spotlight {
            float: right;
        }
    }

    .filtered-result-row:not(.filtered-result-heading):hover {
        background-color: #303034;
        .ue-icon-arrow-right {
            transform: translateX(0);
        }
    }

    a {
        color: #fff;
        text-decoration: none;
    }

    ${(p) => p.theme.breakpoints.up('lg')} {
        .filtered-result-row {
            border-bottom: 1px solid #303034;
            margin: initial;
            padding-top: 20px;
            padding-bottom: 15px;
        }
    }

    .filtered-result-heading span {
        font-weight: 700;
    }

    .rightCarret {
        text-align: right;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        .ue-icon-arrow-right {
            transform: translateX(-5px);
            transition: transform 0.25s ${(p) => p.theme.easing};
        }
    }
`;
export const TagPills = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    min-height: 32px;
    font-size: 14px;

    .tag-pill {
        margin-top: 5px;
        background: #303034;
        color: #e6e6ea;
    }
`;

export const SearchBox = styled.div`
    background-color: #202024;

    ${(p) => p.theme.breakpoints.up('lg')} {
        float: right;
        border-left: 1px solid #303034;
    }
    ${(p) => p.theme.breakpoints.only('md')} {
        input {
            width: 95%;
        }
    }

    svg {
        margin-left: 15px;
        position: relative;
        top: 5px;
        path {
            fill: #aaaaae;
        }
    }

    input {
        background-color: #202024;
        caret-color: #fff;
        color: #fff;
        border: 0px;
        height: 50px;
        padding-left: 15px;
        padding-right: 20px;
        outline: none;

        max-width: 300px;
    }
`;

export const LocationInputs = styled.section`
    .select-dropdown {
        background-color: #202024;
        color: #e6e6ea;
        padding: 30px;
        width: 300px;
    }

    select {
        background-color: #202024;
        color: #e6e6ea;
        border: none;
        padding: 15px;
        width: 100%;
        &::placeholder {
            color: #757575;
        }
        option:not(:first-of-type) {
            color: #e6e6ea;
        }
    }

    select#uncontrolled-native {
        padding-top: 0px;
    }

    .location-select-dropdown {
        background-color: #202024;
        width: 100%;
        margin-bottom: 20px;
        path {
            stroke: #aaaaae;
        }
    }

    select:focus {
        background-color: initial;
    }

    .location-select-dropdown svg {
        margin-right: 10px;
    }
`;
